import { showToast } from "./Utils";

export const handleRTKQuery = async (
    fetchData: any,
    onSuccess?: (response: any) => void,
    onFailure?: (error: any) => void,
    onComplete?: () => void
) => {
    try {
        const response = await fetchData();
        // Handle API logical failure
        if (response?.success === false || response?.status >= 400) {
            const message = response?.message || "An error occurred";
            showToast(message, "error");
            onFailure?.(response);
        } else {
            onSuccess?.(response);
        }

        return response;
    } catch (error: any) {
        const message = error?.data?.message || error?.message || "An error occurred";
        showToast(message, "error");
        onFailure?.(error);
        throw error; // Optional: re-throw if caller needs to catch
    } finally {
        onComplete?.();
    }
};


export const getAuthorizationHeader = () => {
    const headers: Record<string, string> = {};

    const token = localStorage.getItem("authToken");
    if (token) {
        headers['Authorization'] = token;
    }

    const tenantUrl = window?.location?.host;
    if (tenantUrl) {
        headers['X-Tenant-Url'] = tenantUrl;
    }

    return headers;
}

export const getFileDownloadHeaders = () => {
    return {
        ...getAuthorizationHeader(),
        'Content-Disposition': "attachment; filename=template.csv",
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
}

export const handleQueryError = async (queryFulfilled: Promise<any>) => {
    queryFulfilled.catch(error => {
        showToast(error?.error?.message, "error");
    })
}


export const handleQueryErrorAndSuccess = async (
    queryFulfilled: Promise<any>,
    action: 'Created' | 'Updated' | 'Deleted' | 'Reset' | 'Assigned' | string,
    entityName: string
) => {
    try {
        const result = await queryFulfilled;

        // If result has an "error" key or "status" >= 400, treat as error
        const isError =
            result?.error ||
            result?.data?.error ||
            result?.data?.status >= 400 ||
            result?.data?.errorCode >= 400;

        if (isError) {
            const errorMessage = result?.data?.message || result?.error || result?.message || "An error occurred";
            showToast(errorMessage, "error");
        } else {
            showToast(`${action} ${entityName} successfully!`, "success");
        }
    } catch (error: any) {
        const errMsg = error?.data?.message || error?.message || "An error occurred";
        showToast(errMsg, "error");
    }
};



